import QA from 'models/QA';
import Notifications from 'libs/notifications';

const running = new Set();
export const qualityEnabled = (settings) => !!settings?.ai_quality_available?.checked && !!settings?.ai_quality_model?.value;
export const qualityForSegment = (result, segment) => result && result.sourceText === segment?.sourceText && result.targetText === segment?.translationText ? result : null;

export async function runAiQuality(taskIDs, { viewID, segmentID, onResults, onProgress } = {}) {
	const ids = [...new Set(taskIDs.map(Number).filter(Boolean))];
	if (!ids.length) return Notifications.warning('Please select at least one task.');
	if (ids.some((id) => running.has(id))) return Notifications.warning('AI Quality is already running for a selected task.');
	ids.forEach((id) => running.add(id));
	const notice = Notifications.loading('Running AI Quality...');
	try {
		for (const taskID of ids) {
			let offset = 0;
			do {
				const response = await QA.aiQuality({ taskID, viewID, run: true, offset, ...(segmentID ? { segmentID } : {}) });
				if (response?.resp !== true) throw new Error(response?.error || 'AI Quality request failed.');
				onResults?.(taskID, response.segments);
				onProgress?.(response.nextOffset, response.total);
				if (response.nextOffset >= response.total) break;
				if (response.nextOffset <= offset) throw new Error('AI Quality made no progress.');
				offset = response.nextOffset;
			} while (true);
		}
		Notifications.success('AI Quality completed.');
	} catch (error) {
		Notifications.error(error?.message || 'AI Quality failed. Please retry.');
	} finally {
		notice.hide();
		ids.forEach((id) => running.delete(id));
	}
}

export const matchesAiQualityFilter = (result, segment, filter) => {
	if (!filter?.enabled) return true;
	const current = qualityForSegment(result, segment);
	const [min, max] = filter.values ?? [0, 100];
	return !!current && Number.isFinite(current.overallScore) && current.overallScore >= min && current.overallScore <= max;
};
